import { Route, Redirect } from "react-router-dom";
const AuthMiddleware = ({
    Component,
    isAuthenticatedRoute,
    Layout,
    ...rest
}) => (
    <Route
       {...rest}
        render={props => {
            if (isAuthenticatedRoute && !localStorage.getItem('token')) {
                return (
                    <Redirect
                        to={{ pathname: '/login',state: { from: props.location } }}
                    />
                )
            }

            return (
                <Layout>
                    <Component {...props} />
                </Layout>
            )
        }}
    />
)

export default AuthMiddleware